/**
 * PrimeVue Preset for Founders Pledge Design System
 * Matches design tokens from tailwind-shared.css
 * Composed from all component presets in ./components (no need to update this file when adding presets).
 */

const componentModules = import.meta.glob<{ default: Record<string, unknown> }>(
  './components/*.ts',
  { eager: true }
)

const preset = Object.values(componentModules).reduce<Record<string, unknown>>(
  (acc, mod) => (mod?.default ? { ...acc, ...mod.default } : acc),
  {}
)

export default preset
